
import { format } from "date-fns";
import { nl } from "date-fns/locale";
import { useState } from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { ProfileDialog } from "./ProfileDialog";

interface UserHeaderProps {
  user: {
    id?: string;
    display_name: string | null;
    username: string | null;
    avatar_url: string | null;
  } | null;
  updated_at: string;
}

export function UserHeader({ user, updated_at }: UserHeaderProps) {
  const [showProfile, setShowProfile] = useState(false);
  const displayName = user?.display_name || user?.username || "Naamloos";

  return (
    <>
      <div className="flex flex-row items-center space-y-0 gap-2">
        <Button
          variant="ghost"
          className="p-0 h-auto hover:bg-transparent"
          onClick={() => setShowProfile(true)}
        >
          <Avatar className="h-8 w-8">
            <AvatarImage src={user?.avatar_url || undefined} />
            <AvatarFallback>{displayName[0].toUpperCase()}</AvatarFallback>
          </Avatar>
        </Button>
        <div className="flex-1">
          <Button
            variant="link"
            className="p-0 h-auto font-medium"
            onClick={() => setShowProfile(true)}
          >
            {displayName}
          </Button>
          <div className="text-sm text-muted-foreground">
            {format(new Date(updated_at), "d MMMM yyyy", { locale: nl })}
          </div>
        </div>
      </div>

      <ProfileDialog 
        userId={user?.id || null}
        open={showProfile}
        onOpenChange={setShowProfile}
      />
    </>
  );
}
